var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view map active"},[_c('div',{staticClass:"view-container",attrs:{"id":'map_container_'+_vm.id}}),_vm._v(" "),_c('div',{staticClass:"btn-fixed btn-position active",class:{ 'loading' : _vm.loadingPosition },on:{"click":function($event){return _vm.triggerSetCurrentLocation()}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }